import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { WorkerService } from '@/infra/services/worker';

interface DestroyWorkerParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = WorkerService.getInstance();

export const useDestroyWorker = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: DestroyWorkerParams) => Service.destroy(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_WORKER]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_WORKER]);
			message.success(I18n.get('Worker destroyed successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on destroy worker'));
		}
	});
};
